class FJNewsletterModal {
  constructor() {
    this.modal = document.getElementById('fj-newsletter-modal');
    if (!this.modal) return;

    this.triggers = document.querySelectorAll('[data-open-newsletter]');

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.modal.querySelectorAll('[data-newsletter-modal-close]').forEach((el) => {
      el.addEventListener('click', this.close.bind(this));
    });

    this.handlePostSubmitRedirect();
  }

  handlePostSubmitRedirect() {
    const params = new URLSearchParams(window.location.search);
    const subscribed = params.get('subscribed');

    if (subscribed === 'modal') {
      this.open();

      const bannerSuccess = document.querySelector('[data-newsletter-success]');
      const bannerForm = document.querySelector('[data-newsletter-form]');
      if (bannerSuccess) bannerSuccess.hidden = true;
      if (bannerForm) bannerForm.hidden = false;
    }
  }

  open() {
    this.modal.classList.add('fj-newsletter-modal--open');
    document.body.classList.add('fj-scroll-lock');
  }

  close() {
    this.modal.classList.remove('fj-newsletter-modal--open');
    document.body.classList.remove('fj-scroll-lock');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FJNewsletterModal();
});